import $ from 'jquery';

$( '.consultation-product-images .thumb div' ).on( 'click', function ( e ) {

  var $thumb = $( this );
  var index = $thumb.index();

  $( '.consultation-product-images .large div' ).hide();
  $( '.consultation-product-images .thumb .active' ).removeClass( 'active' );

  $( '.consultation-product-images .large div:eq(' + index + ')' ).show();
  $thumb.addClass( 'active' );

});

$( '.consultation-product-images .thumb div:eq(0)' ).click();
